import { Controller } from 'stimulus';
import { toArray } from 'lodash';

class MasonryController extends Controller {
  connect() {
    if (!this.gridTarget) {
      console.error('masonry grid not found');
      return;
    }

    this.grid = this.gridTarget;
    this.items = toArray(this.grid.children);

    this.breakpoints = {
      0: 1,
      560: 2,
      1500: 3,
    };

    // Keep track of which number of columns is already
    // rendered, to prevent updates on every resize change.
    this.lastNumberOfColumns = null;

    this.rebuildMasonry();

    window.addEventListener('resize', this.rebuildMasonry.bind(this), { passive: true });
  }

  rebuildMasonry() {
    // Clone the list of available grid items
    const itemsToPlace = [...this.items];
    let columns = 1;

    Object.keys(this.breakpoints).forEach((breakpoint) => {
      if (window.matchMedia(`(min-width: ${breakpoint}px`).matches) {
        columns = this.breakpoints[breakpoint];
      }
    });

    if (this.lastNumberOfColumns === columns) {
      return;
    }

    this.lastNumberOfColumns = columns;

    this.grid.innerHTML = '';

    const columnNodes = [];

    for (let i = 0; i < columns; i += 1) {
      const columnNode = document.createElement('div');
      columnNode.className = 'grid-col';
      columnNodes.push(columnNode);

      this.grid.appendChild(columnNode);
    }

    for (let i = 0; i < itemsToPlace.length; i += 1) {
      // Get the column index we've to place this grid item in.
      // For example i=1 will place the grid item in the second column.
      const columnToPlace = i % columns;
      const columnToPlaceNode = columnNodes[columnToPlace];

      columnToPlaceNode.appendChild(itemsToPlace[i]);
    }
  }

  disconnect() {
    window.removeEventListener('resize', this.rebuildMasonry.bind(this), { passive: true });
  }
}

MasonryController.targets = [
  'grid',
];

export default MasonryController;
